export default __webpack_public_path__ + "static/taegeun.moon-d8320255d43a8ae01dbdde1556f2a45c.jpeg";